document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll(".product-page-zoomable-image").forEach(function(img) {
    img.addEventListener("click", function() {
      // 创建遮罩层
      const modal = document.createElement("div");
      modal.style.position = "fixed";
      modal.style.top = "0";
      modal.style.left = "0";
      modal.style.width = "100%";
      modal.style.height = "100%";
      modal.style.background = "rgba(0,0,0,0.8)";
      modal.style.display = "flex";
      modal.style.alignItems = "center";
      modal.style.justifyContent = "center";
      modal.style.zIndex = "9999";

      // 创建图片元素
      const modalImg = document.createElement("img");
      modalImg.src = img.src;
      modalImg.style.maxWidth = "100%";
      modalImg.style.maxHeight = "100%";
      modalImg.style.borderRadius = "5px";

      // 点击遮罩层关闭
      modal.addEventListener("click", () => modal.remove());

      modal.appendChild(modalImg);
      document.body.appendChild(modal);
    });
  });
});
